/* ============================================================
   THE SOLE STORE — Bespoke PDP  (Horizon theme)
   assets/solestore-pdp.js
   Vanilla JS, no dependencies. Handles: size/variant selection,
   price + CTA sync, sticky checkout bar, recommendations.
   (Accordions use native <details>; ticker/reviews are Phase 2.)
   ============================================================ */
(function () {
  document.querySelectorAll('.ss-pdp').forEach(initPDP);

  function initPDP(root) {
    var form      = root.querySelector('#ss-product-form');
    var idInput   = root.querySelector('[data-variant-id]');
    var priceEl   = root.querySelector('[data-price]');
    var addBtn    = root.querySelector('[data-add-btn]');
    var ctaText   = root.querySelector('[data-cta-text]');
    var sizeBtns  = root.querySelectorAll('.ss-sizebtn');
    var variants  = readJSON(root.querySelector('[data-ss-variants]'));

    // ---- Fly-to-cart animation ----
    // Clones the current product image and animates it into the header cart icon.
    // Purely visual; runs alongside the AJAX add and never blocks it.
    function flyToCart() {
      try {
        // Launch point: the Add to Basket button itself.
        if (!addBtn) return;
        var b = addBtn.getBoundingClientRect();
        if (!b.width) return;

        var cartIcon = document.querySelector('cart-icon') ||
                       document.querySelector('.header-actions__cart-icon') ||
                       document.querySelector('[href*="/cart"]');
        var t = cartIcon ? cartIcon.getBoundingClientRect() : { width: 0, height: 0 };

        // If the cart icon isn't measurable (e.g. tucked in a closed mobile
        // header), fly to the top-right corner where the cart lives instead.
        var target;
        if (t.width && t.height) {
          target = { x: t.left + t.width / 2, y: t.top + t.height / 2 };
        } else {
          target = { x: window.innerWidth - 28, y: 30 };
        }

        // A small circular badge holding a shopping-bag icon.
        var size = 40;
        var startX = b.left + b.width / 2 - size / 2;   // centre of the button
        var startY = b.top + b.height / 2 - size / 2;
        var endX = target.x - size / 2;
        var endY = target.y - size / 2;

        var fly = document.createElement('div');
        fly.setAttribute('aria-hidden', 'true');
        fly.innerHTML =
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" ' +
          'stroke="#ffffff" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>' +
          '<path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
        fly.style.cssText =
          'position:fixed;z-index:9999;pointer-events:none;left:0;top:0;' +
          'width:' + size + 'px;height:' + size + 'px;border-radius:50%;' +
          'background:#0b0b0b;display:flex;align-items:center;justify-content:center;' +
          'box-shadow:0 10px 26px rgba(0,0,0,.3);' +
          'transform:translate(' + startX + 'px,' + startY + 'px) scale(1);' +
          'opacity:1;will-change:transform,opacity;' +
          'transition:transform .8s cubic-bezier(.55,-.35,.35,1.2),opacity .8s ease;';
        document.body.appendChild(fly);

        // Force a reflow so the starting transform is committed before we animate.
        void fly.offsetWidth;

        fly.style.transform =
          'translate(' + endX + 'px,' + endY + 'px) scale(0.35)';
        fly.style.opacity = '0.4';

        // A quick pulse on the cart icon as the bag "lands" (only if measurable).
        if (t.width && t.height) {
          setTimeout(function () {
            cartIcon.style.transition = 'transform .25s ease';
            cartIcon.style.transform = 'scale(1.25)';
            setTimeout(function () { cartIcon.style.transform = ''; }, 250);
          }, 620);
        }

        fly.addEventListener('transitionend', function () {
          if (fly.parentNode) fly.parentNode.removeChild(fly);
        });
        // Safety cleanup in case transitionend doesn't fire.
        setTimeout(function () { if (fly.parentNode) fly.parentNode.removeChild(fly); }, 1200);
      } catch (e) { /* animation is non-critical */ }
    }

    // ---- AJAX add to basket (silent — no redirect, no drawer) ----
    // Bind to the button's click in the CAPTURE phase and stop propagation so
    // Horizon's own product-form component can't also handle (or hijack) it.
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        doAdd();
      }, true);
    }
    // Also catch a normal form submit as a backstop (e.g. Enter key).
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        doAdd();
      }, true);
    }

    var adding = false;
    function doAdd() {
      if (adding) return;
      if (addBtn && addBtn.disabled) return;
      // Build the id from the hidden input (kept in sync by size selection).
      var variantId = idInput ? idInput.value : null;
      if (!variantId) { return; }
      adding = true;

      // Fire the visual fly-to-cart the instant a valid add starts.
      flyToCart();

      var original = ctaText ? ctaText.textContent : '';
      if (ctaText) ctaText.textContent = 'Adding…';
      if (addBtn) addBtn.disabled = true;

      var body = {
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-icon-bubble,cart-drawer,cart-notification',
        sections_url: window.location.pathname
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function (data) {
        if (ctaText) ctaText.textContent = 'Added ✓';
        updateCart(data);
        setTimeout(function () {
          if (ctaText) ctaText.textContent = original || 'Add to Basket';
          if (addBtn) addBtn.disabled = false;
          adding = false;
        }, 1400);
      })
      .catch(function (err) {
        if (ctaText) ctaText.textContent = (err && err.description) ? err.description : 'Unavailable';
        setTimeout(function () {
          if (ctaText) ctaText.textContent = original || 'Add to Basket';
          if (addBtn) addBtn.disabled = false;
          adding = false;
        }, 1800);
      });
    }

    // Update the cart UI without a page refresh.
    // Horizon renders the count inside a <cart-icon> web component (cart-icon.js)
    // via the 'cart-bubble' snippet. We fire the events its JS listens for, then
    // re-render the header cart markup as a guaranteed fallback.
    function updateCart(addData) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = cart.item_count;

          // (A) Events Horizon's components listen for.
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              data: { itemCount: count, source: 'product-form-component' },
              source: 'product-form-component',
              itemCount: count,
              sections: (addData && addData.sections) || {}
            }
          }));
          try {
            import('@theme/events').then(function (mod) {
              if (mod && mod.CartUpdateEvent) {
                document.dispatchEvent(new mod.CartUpdateEvent(cart, 'ss-pdp', {
                  itemCount: count, source: 'ss-pdp', sections: (addData && addData.sections) || {}
                }));
              }
            }).catch(function () {});
          } catch (e) {}
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          // (B) Guaranteed fallback: re-render the header so <cart-icon> markup is fresh,
          //     and mark it as having a cart so the bubble shows.
          var cartIcon = document.querySelector('cart-icon');
          if (cartIcon) {
            if (count > 0) cartIcon.classList.add('header-actions__cart-icon--has-cart');
            else cartIcon.classList.remove('header-actions__cart-icon--has-cart');
          }
          refreshHeaderCart(count);
          refreshCartDrawer();
        })
        .catch(function () {});
    }

    // Re-render the cart drawer's contents so it shows the items without a page
    // refresh. Horizon's drawer is a <cart-drawer-component>; we pull its section
    // fresh and swap the inner markup, then let its own JS re-bind.
    function refreshCartDrawer() {
      var drawer = document.querySelector('cart-drawer-component, cart-drawer');
      if (!drawer) return;
      var wrapper = drawer.closest('.shopify-section');
      var sectionId = wrapper ? wrapper.id.replace('shopify-section-', '') : 'cart-drawer';

      fetch('/?section_id=' + sectionId)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('cart-drawer-component, cart-drawer');
          if (fresh && drawer) {
            drawer.innerHTML = fresh.innerHTML;
            drawer.classList.remove('is-empty');
            // If the theme exposes a render hook, use it too.
            if (typeof drawer.renderContents === 'function') {
              try { drawer.renderContents({}); } catch (e) {}
            }
          }
        })
        .catch(function () {});
    }

    // Pull the header section fresh and replace the <cart-icon> node so the
    // count bubble updates even if the theme's own JS didn't catch the event.
    function refreshHeaderCart(count) {
      // Find which shopify-section wraps the header so we can re-render it.
      var headerSection = document.querySelector('cart-icon');
      var wrapper = headerSection ? headerSection.closest('.shopify-section') : null;
      var sectionId = wrapper ? wrapper.id.replace('shopify-section-', '') : 'header';

      fetch('/?section_id=' + sectionId)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshIcon = doc.querySelector('cart-icon');
          var liveIcon  = document.querySelector('cart-icon');
          if (freshIcon && liveIcon) {
            // Replace only the inner bubble/count, not the whole custom element
            // (so we don't detach its event listeners).
            liveIcon.innerHTML = freshIcon.innerHTML;
            liveIcon.className = freshIcon.className;
          }
        })
        .catch(function () {});
    }

    // Kept for backward compat; not used for Horizon's cart-icon.
    function replaceSection() {}

    // ---- gallery: desktop thumbnail swap + mobile swipe carousel + shared lightbox ----
    (function initGallery() {
      var mainImg = root.querySelector('[data-ss-mainimg]');
      var thumbs  = Array.prototype.slice.call(root.querySelectorAll('[data-ss-thumb]'));
      var mSlides = Array.prototype.slice.call(root.querySelectorAll('[data-ss-mslide]'));
      var lb      = root.querySelector('[data-ss-lightbox]');
      if (!lb) return;
      var lbImg   = lb.querySelector('[data-ss-lbimg]');
      var lbClose = lb.querySelector('[data-ss-lbclose]');
      var lbPrev  = lb.querySelector('[data-ss-lbprev]');
      var lbNext  = lb.querySelector('[data-ss-lbnext]');

      // Build the ordered zoom list. Prefer the mobile slides (they list ALL media
      // in order: 0..n). Fall back to desktop main+thumbs. Both produce the same
      // ordered set, so lightbox indices line up whichever gallery is on screen.
      var zoomList = [];
      if (mSlides.length) {
        zoomList = mSlides.map(function (s) { return s.getAttribute('data-zoom'); });
      } else if (mainImg) {
        zoomList = [mainImg.getAttribute('data-zoom')].concat(
          thumbs.map(function (t) { return t.getAttribute('data-zoom'); })
        );
      }
      var current = 0; // index into zoomList
      var lbMoved = false; // true when a touch turned into a drag/swipe (guards close-on-tap)

      // ---- DESKTOP: thumbnail + main-image clicks open the lightbox ----
      if (mainImg) {
        mainImg.style.cursor = 'zoom-in';
        mainImg.addEventListener('click', function () { openLightbox(current); });
      }
      thumbs.forEach(function (thumb, i) {
        thumb.style.cursor = 'zoom-in';
        thumb.addEventListener('click', function () { openLightbox(i + 1); });
      });

      // ---- MOBILE: tap a slide to open the lightbox at that image ----
      mSlides.forEach(function (slide) {
        slide.addEventListener('click', function () {
          var idx = parseInt(slide.getAttribute('data-index'), 10) || 0;
          openLightbox(idx);
        });
      });

      function openLightbox(i) {
        if (!zoomList.length) return;
        current = (i + zoomList.length) % zoomList.length;
        lbImg.src = zoomList[current];
        lb.hidden = false;
        document.body.style.overflow = 'hidden';
      }
      function closeLightbox() {
        lb.hidden = true;
        document.body.style.overflow = '';
      }
      function step(dir) { openLightbox(current + dir); }

      if (lbClose) lbClose.addEventListener('click', closeLightbox);
      if (lbPrev)  lbPrev.addEventListener('click', function () { step(-1); });
      if (lbNext)  lbNext.addEventListener('click', function () { step(1); });
      lb.addEventListener('click', function (e) {
        if (lbMoved) { lbMoved = false; return; } // ignore the click that ends a swipe
        if (e.target === lb) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        else if (e.key === 'ArrowLeft') step(-1);
        else if (e.key === 'ArrowRight') step(1);
      });

      if (zoomList.length < 2) {
        if (lbPrev) lbPrev.style.display = 'none';
        if (lbNext) lbNext.style.display = 'none';
      }

      // ---- MOBILE carousel: sync dots on scroll + tap a dot to scroll to slide ----
      (function initMobileCarousel() {
        var track = root.querySelector('[data-ss-mtrack]');
        var dotsWrap = root.querySelector('[data-ss-mdots]');
        if (!track || !mSlides.length) return;
        var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('.ss-mdot')) : [];

        function setActive(idx) {
          dots.forEach(function (d, i) { d.classList.toggle('on', i === idx); });
        }

        // Update the active dot as the track scrolls (debounced via rAF).
        var ticking = false;
        track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            var idx = Math.round(track.scrollLeft / track.clientWidth);
            if (idx < 0) idx = 0;
            if (idx > mSlides.length - 1) idx = mSlides.length - 1;
            setActive(idx);
            ticking = false;
          });
        }, { passive: true });

        // Tap a dot to jump to that slide.
        dots.forEach(function (dot, i) {
          dot.style.cursor = 'pointer';
          dot.addEventListener('click', function () {
            track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
            setActive(i);
          });
        });
      })();

      // ---- swipe left/right inside the lightbox (mobile) ----
      // Bound to the whole overlay (not just the image) so a flick anywhere in
      // the zoomed view browses to the next/previous image. lbMoved guards the
      // tap-outside-to-close handler so a swipe doesn't also close the lightbox.
      var swipeStartX = 0, swipeStartY = 0, swiping = false;
      var SWIPE_MIN = 40; // px of horizontal travel to count as a swipe
      lb.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        swipeStartX = e.touches[0].clientX;
        swipeStartY = e.touches[0].clientY;
        swiping = true;
        lbMoved = false;
      }, { passive: true });
      lb.addEventListener('touchmove', function (e) {
        if (!swiping) return;
        var dx = e.touches[0].clientX - swipeStartX;
        var dy = e.touches[0].clientY - swipeStartY;
        if (Math.abs(dx) > 8 || Math.abs(dy) > 8) lbMoved = true;
        // if it's mostly a vertical move, cancel (let it scroll/close naturally)
        if (Math.abs(dy) > Math.abs(dx)) swiping = false;
      }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (!swiping) return;
        swiping = false;
        var dx = e.changedTouches[0].clientX - swipeStartX;
        if (dx <= -SWIPE_MIN) step(1);        // swipe left → next
        else if (dx >= SWIPE_MIN) step(-1);   // swipe right → previous
      }, { passive: true });
    })();

    // ---- size / variant selection ----
    sizeBtns.forEach(function (btn) {
      if (btn.disabled) return;
      btn.addEventListener('click', function () {
        sizeBtns.forEach(function (b) { b.classList.remove('sel'); });
        btn.classList.add('sel');
        var vid = btn.getAttribute('data-variant');
        if (vid) selectVariant(vid, btn);
      });
    });

    function selectVariant(vid, btn) {
      if (idInput) idInput.value = vid;
      var v = findVariant(vid);
      if (v && priceEl) priceEl.textContent = formatMoney(v.price);
      if (ctaText) {
        var label = btn ? btn.querySelector('.ss-szn').textContent.trim() : '';
        ctaText.textContent = 'Add to Basket' + (label ? '  ·  ' + label : '');
      }
      if (addBtn) addBtn.disabled = v ? !v.available : false;
      // keep sticky bar in sync
      var sbSub = root.querySelector('[data-sb-sub]');
      var sbPrice = root.querySelector('[data-sb-price]');
      if (sbSub && btn) sbSub.textContent = btn.querySelector('.ss-szn').textContent.trim();
      if (sbPrice && v) sbPrice.textContent = formatMoney(v.price);
    }

    function findVariant(vid) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(vid)) return variants[i];
      }
      return null;
    }

    // ---- sticky checkout bar (show once buy box scrolls past) ----
    var sbar   = root.querySelector('[data-sticky-bar]');
    var buyBox = root.querySelector('.ss-buy');
    if (sbar && buyBox) {
      sbar.hidden = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          sbar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      io.observe(buyBox);

      var sbAdd = root.querySelector('[data-sb-add]');
      if (sbAdd) sbAdd.addEventListener('click', function () {
        if (addBtn && !addBtn.disabled) {
          doAdd();
        } else {
          buyBox.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }

    // ---- helpers ----
    function formatMoney(cents) {
      // Uses the theme's active currency format if available.
      var fmt = (window.Shopify && Shopify.money_format) || '£{{amount}}';
      var amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount\s*\}\}/, amount)
                .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }
    function readJSON(el) { try { return JSON.parse(el.textContent) || []; } catch (e) { return []; } }
  }
})();